import { TablePagination } from '@mui/material';
import { memo } from 'react';

const CustomTablePagination = memo(({ rowsPerPage, rowsPerPageOptions, page, onPageChange, onRowsPerPageChange, count }) => {
  console.log({
    rowsPerPage,
    rowsPerPageOptions,
    page,
    onPageChange,
    onRowsPerPageChange,
    count,
  });
  return (
    <TablePagination
      sx={{
        marginRight: '25px',
      }}
      align="right"
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      count={count}
    />
  );
});

export default CustomTablePagination;
